import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui/IconButton';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { resolveTheme } from '@/entities/preferences/lib/applyPrefs';

export function ThemeToggle() {
  const { t } = useTranslation();
  const theme = usePrefsStore((s) => s.prefs.theme);
  const setPrefs = usePrefsStore((s) => s.set);
  const isDark = resolveTheme(theme) === 'dark';
  return (
    <IconButton
      label={t('shell.user.darkMode')}
      onClick={() => setPrefs({ theme: isDark ? 'light' : 'dark' })}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </IconButton>
  );
}
